export enum TooltipPosition {
  BOTTOM = 'BOTTOM'
}

export interface ITooltipProps {
  message: string;
  position: TooltipPosition;
}